import * as modalWindowActions from 'root/modal/modalWindowActions';
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { ModalEnum } from 'myParkdUtils/enums';


const ClickableInfoIcon = (props: Props) => (
    <sup
        onClick={e => {
            e.stopPropagation();
            props.updateModal(
                props.modal,
                props.modal === ModalEnum.INFO_MODAL ? {
                    modalTitleFormattedMessageId: props.modalTitleFormattedMessageId,
                    modalTextFormattedMessageId: props.modalTextFormattedMessageId
                } : null
            );
        }}
        className="get-more-info-icon"
    >
        <FontAwesomeIcon icon={faInfoCircle} />
    </sup>
);


interface OwnProps {
    modal: ModalEnum,
    modalTitleFormattedMessageId?: string,
    modalTextFormattedMessageId?: string
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        updateModal: modalWindowActions.updateModalWindow
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(ClickableInfoIcon);